import { primitives } from "../colors/pinkPanther.js";
import { createColorLightTokens, createColorDarkTokens } from "../utils/createColorTokens.js";
import { fontTokens } from "../fonts/fonts.js";
import { radiusTokens } from "../radius/radius.js";
var lightTokens = {
  mode: 'light',
  color: createColorLightTokens(primitives),
  font: fontTokens,
  radius: radiusTokens
};
var darkTokens = {
  mode: 'dark',
  color: createColorDarkTokens(primitives),
  font: fontTokens,
  radius: radiusTokens
};
export var pinkPantherKallistoTokens = {
  light: lightTokens,
  dark: darkTokens
};